"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CellText = function CellText(props) {
  var _props$valueClassName = props.valueClassName,
      valueClassName = _props$valueClassName === void 0 ? '' : _props$valueClassName,
      column = props.column,
      value = props.value,
      _props$children = props.children,
      children = _props$children === void 0 ? function () {
    return null;
  } : _props$children;
  var _column$align = column.align,
      align = _column$align === void 0 ? 'left' : _column$align;
  var className = "text-".concat(align);
  return /*#__PURE__*/_react.default.createElement("td", {
    className: className
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children(props)), /*#__PURE__*/_react.default.createElement("p", {
    className: valueClassName
  }, value));
};

CellText.propTypes = {
  column: _propTypes.default.shape({
    align: _propTypes.default.string
  }),
  value: _propTypes.default.any,
  valueClassName: _propTypes.default.string,
  children: _propTypes.default.func
};
var _default = CellText;
exports.default = _default;